// Indonesian complete cities and regencies list
// Used by Branches.jsx and Peta.jsx
export const INDONESIAN_CITIES = [
  // ===== ACEH =====
  'Banda Aceh', 'Langsa', 'Lhokseumawe', 'Sabang', 'Subulussalam',
  'Aceh Barat', 'Aceh Barat Daya', 'Aceh Besar', 'Aceh Jaya', 'Aceh Selatan',
  'Aceh Singkil', 'Aceh Tamiang', 'Aceh Tengah', 'Aceh Tenggara', 'Aceh Timur',
  'Aceh Utara', 'Bener Meriah', 'Bireuen', 'Gayo Lues', 'Nagan Raya',
  'Pidie', 'Pidie Jaya', 'Simeulue',
  
  // ===== SUMATERA UTARA =====
  'Medan', 'Binjai', 'Padangsidimpuan', 'Pematangsiantar', 'Sibolga', 'Tanjungbalai', 'Tebing Tinggi', 'Gunungsitoli',
  'Asahan', 'Batubara', 'Dairi', 'Deli Serdang', 'Humbang Hasundutan', 'Karo',
  'Labuhanbatu', 'Labuhanbatu Selatan', 'Labuhanbatu Utara', 'Langkat', 'Mandailing Natal',
  'Nias', 'Nias Barat', 'Nias Selatan', 'Nias Utara', 'Padang Lawas', 'Padang Lawas Utara',
  'Pakpak Bharat', 'Samosir', 'Serdang Bedagai', 'Simalungun', 'Tapanuli Selatan',
  'Tapanuli Tengah', 'Tapanuli Utara', 'Toba Samosir',
  
  // ===== SUMATERA BARAT =====
  'Padang', 'Bukittinggi', 'Padang Panjang', 'Pariaman', 'Payakumbuh', 'Sawahlunto', 'Solok',
  'Agam', 'Dharmasraya', 'Kepulauan Mentawai', 'Lima Puluh Kota', 'Padang Pariaman',
  'Pasaman', 'Pasaman Barat', 'Pesisir Selatan', 'Sijunjung', 'Solok Selatan', 'Tanah Datar',
  
  // ===== RIAU =====
  'Pekanbaru', 'Dumai',
  'Bengkalis', 'Indragiri Hilir', 'Indragiri Hulu', 'Kampar', 'Kepulauan Meranti',
  'Kuantan Singingi', 'Pelalawan', 'Rokan Hilir', 'Rokan Hulu', 'Siak',
  
  // ===== KEPULAUAN RIAU =====
  'Tanjung Pinang', 'Batam',
  'Bintan', 'Karimun', 'Kepulauan Anambas', 'Lingga', 'Natuna',
  
  // ===== JAMBI =====
  'Jambi', 'Sungai Penuh',
  'Batanghari', 'Bungo', 'Kerinci', 'Merangin', 'Muaro Jambi', 'Sarolangun',
  'Tanjung Jabung Barat', 'Tanjung Jabung Timur', 'Tebo',
  
  // ===== SUMATERA SELATAN =====
  'Palembang', 'Lubuklinggau', 'Pagar Alam', 'Prabumulih',
  'Banyuasin', 'Empat Lawang', 'Lahat', 'Muara Enim', 'Musi Banyuasin', 'Musi Rawas',
  'Musi Rawas Utara', 'Ogan Ilir', 'Ogan Komering Ilir', 'Ogan Komering Ulu',
  'Ogan Komering Ulu Selatan', 'Ogan Komering Ulu Timur', 'Penukal Abab Lematang Ilir',
  
  // ===== BENGKULU =====
  'Bengkulu',
  'Bengkulu Selatan', 'Bengkulu Tengah', 'Bengkulu Utara', 'Kaur', 'Kepahiang',
  'Lebong', 'Mukomuko', 'Rejang Lebong', 'Seluma',
  
  // ===== LAMPUNG =====
  'Bandar Lampung', 'Metro',
  'Lampung Barat', 'Lampung Selatan', 'Lampung Tengah', 'Lampung Timur', 'Lampung Utara',
  'Mesuji', 'Pesawaran', 'Pesisir Barat', 'Pringsewu', 'Tanggamus', 'Tulang Bawang',
  'Tulang Bawang Barat', 'Way Kanan',
  
  // ===== BANGKA BELITUNG =====
  'Pangkal Pinang',
  'Bangka', 'Bangka Barat', 'Bangka Selatan', 'Bangka Tengah', 'Belitung', 'Belitung Timur',
  
  // ===== DKI JAKARTA =====
  'Jakarta', 'Jakarta Barat', 'Jakarta Pusat', 'Jakarta Selatan', 'Jakarta Timur', 'Jakarta Utara',
  'Kepulauan Seribu',
  
  // ===== JAWA BARAT =====
  'Bandung', 'Bekasi', 'Bogor', 'Cimahi', 'Cirebon', 'Depok', 'Sukabumi', 'Tasikmalaya', 'Banjar',
  'Bandung Barat', 'Ciamis', 'Cianjur', 'Garut', 'Indramayu', 'Karawang', 'Kuningan',
  'Majalengka', 'Pangandaran', 'Purwakarta', 'Subang', 'Sumedang',
  
  // ===== BANTEN =====
  'Serang', 'Cilegon', 'Tangerang', 'Tangerang Selatan',
  'Lebak', 'Pandeglang',
  
  // ===== JAWA TENGAH =====
  'Semarang', 'Magelang', 'Pekalongan', 'Salatiga', 'Surakarta', 'Tegal',
  'Banjarnegara', 'Banyumas', 'Batang', 'Blora', 'Boyolali', 'Brebes', 'Cilacap',
  'Demak', 'Grobogan', 'Jepara', 'Karanganyar', 'Kebumen', 'Kendal', 'Klaten',
  'Kudus', 'Pati', 'Pemalang', 'Purbalingga', 'Purworejo',
  'Rembang', 'Sragen', 'Sukoharjo', 'Temanggung', 'Wonogiri', 'Wonosobo',
  
  // ===== DI YOGYAKARTA =====
  'Yogyakarta',
  'Bantul', 'Gunungkidul', 'Kulon Progo', 'Sleman',
  
  // ===== JAWA TIMUR =====
  'Surabaya', 'Batu', 'Blitar', 'Kediri', 'Madiun', 'Malang', 'Mojokerto', 'Pasuruan', 'Probolinggo',
  'Bangkalan', 'Banyuwangi', 'Bojonegoro', 'Bondowoso', 'Gresik', 'Jember', 'Jombang',
  'Lamongan', 'Lumajang', 'Magetan', 'Nganjuk', 'Ngawi', 'Pacitan', 'Pamekasan',
  'Ponorogo', 'Sampang', 'Sidoarjo', 'Situbondo', 'Sumenep', 'Trenggalek', 'Tuban', 'Tulungagung',
  
  // ===== KALIMANTAN BARAT =====
  'Pontianak', 'Singkawang',
  'Bengkayang', 'Kapuas Hulu', 'Kayong Utara', 'Ketapang', 'Kubu Raya', 'Landak',
  'Melawi', 'Mempawah', 'Sambas', 'Sanggau', 'Sekadau', 'Sintang',
  
  // ===== KALIMANTAN TENGAH =====
  'Palangkaraya',
  'Barito Selatan', 'Barito Timur', 'Barito Utara', 'Gunung Mas', 'Kapuas', 'Katingan',
  'Kotawaringin Barat', 'Kotawaringin Timur', 'Lamandau', 'Murung Raya', 'Pulang Pisau',
  'Seruyan', 'Sukamara',
  
  // ===== KALIMANTAN SELATAN =====
  'Banjarmasin', 'Banjarbaru',
  'Balangan', 'Banjar', 'Barito Kuala', 'Hulu Sungai Selatan', 'Hulu Sungai Tengah',
  'Hulu Sungai Utara', 'Kotabaru', 'Tabalong', 'Tanah Bumbu', 'Tanah Laut', 'Tapin',
  
  // ===== KALIMANTAN TIMUR =====
  'Samarinda', 'Balikpapan', 'Bontang',
  'Berau', 'Kutai Barat', 'Kutai Kartanegara', 'Kutai Timur', 'Mahakam Ulu',
  'Paser', 'Penajam Paser Utara',
  
  // ===== KALIMANTAN UTARA =====
  'Tarakan',
  'Bulungan', 'Malinau', 'Nunukan', 'Tana Tidung',
  
  // ===== SULAWESI UTARA =====
  'Manado', 'Bitung', 'Kotamobagu', 'Tomohon',
  'Bolaang Mongondow', 'Bolaang Mongondow Selatan', 'Bolaang Mongondow Timur', 'Bolaang Mongondow Utara',
  'Kepulauan Sangihe', 'Kepulauan Siau Tagulandang Biaro', 'Kepulauan Talaud',
  'Minahasa', 'Minahasa Selatan', 'Minahasa Tenggara', 'Minahasa Utara',
  
  // ===== SULAWESI TENGAH =====
  'Palu',
  'Banggai', 'Banggai Kepulauan', 'Banggai Laut', 'Buol', 'Donggala', 'Morowali',
  'Morowali Utara', 'Parigi Moutong', 'Poso', 'Sigi', 'Tojo Una-Una', 'Toli-Toli',
  
  // ===== SULAWESI SELATAN =====
  'Makassar', 'Palopo', 'Parepare',
  'Bantaeng', 'Barru', 'Bone', 'Bulukumba', 'Enrekang', 'Gowa', 'Jeneponto',
  'Kepulauan Selayar', 'Luwu', 'Luwu Timur', 'Luwu Utara', 'Maros', 'Pangkajene dan Kepulauan',
  'Pinrang', 'Sidenreng Rappang', 'Sinjai', 'Soppeng', 'Takalar', 'Tana Toraja',
  'Toraja Utara', 'Wajo',
  
  // ===== SULAWESI TENGGARA =====
  'Kendari', 'Baubau',
  'Bombana', 'Buton', 'Buton Selatan', 'Buton Tengah', 'Buton Utara', 'Kolaka',
  'Kolaka Timur', 'Kolaka Utara', 'Konawe', 'Konawe Kepulauan', 'Konawe Selatan', 'Konawe Utara',
  'Muna', 'Muna Barat', 'Wakatobi',
  
  // ===== GORONTALO =====
  'Gorontalo',
  'Boalemo', 'Bone Bolango', 'Gorontalo Utara', 'Pohuwato',
  
  // ===== SULAWESI BARAT =====
  'Mamuju',
  'Majene', 'Mamasa', 'Mamuju Tengah', 'Pasangkayu', 'Polewali Mandar',
  
  // ===== BALI =====
  'Denpasar',
  'Badung', 'Bangli', 'Buleleng', 'Gianyar', 'Jembrana', 'Karangasem', 'Klungkung', 'Tabanan',
  
  // ===== NUSA TENGGARA BARAT =====
  'Mataram', 'Bima',
  'Dompu', 'Lombok Barat', 'Lombok Tengah', 'Lombok Timur', 'Lombok Utara', 'Sumbawa', 'Sumbawa Barat',
  
  // ===== NUSA TENGGARA TIMUR =====
  'Kupang',
  'Alor', 'Belu', 'Ende', 'Flores Timur', 'Lembata', 'Malaka', 'Manggarai',
  'Manggarai Barat', 'Manggarai Timur', 'Nagekeo', 'Ngada', 'Rote Ndao', 'Sabu Raijua',
  'Sikka', 'Sumba Barat', 'Sumba Barat Daya', 'Sumba Tengah', 'Sumba Timur',
  'Timor Tengah Selatan', 'Timor Tengah Utara',
  
  // ===== MALUKU =====
  'Ambon', 'Tual',
  'Buru', 'Buru Selatan', 'Kepulauan Aru', 'Maluku Barat Daya', 'Maluku Tengah',
  'Maluku Tenggara', 'Maluku Tenggara Barat', 'Seram Bagian Barat', 'Seram Bagian Timur',
  
  // ===== MALUKU UTARA =====
  'Ternate', 'Tidore Kepulauan',
  'Halmahera Barat', 'Halmahera Selatan', 'Halmahera Tengah', 'Halmahera Timur', 'Halmahera Utara',
  'Kepulauan Sula', 'Pulau Morotai', 'Pulau Taliabu',
  
  // ===== PAPUA =====
  'Jayapura',
  'Biak Numfor', 'Jayawijaya', 'Keerom', 'Kepulauan Yapen', 'Lanny Jaya',
  'Mamberamo Raya', 'Mamberamo Tengah', 'Merauke', 'Mimika', 'Nabire', 'Nduga',
  'Paniai', 'Pegunungan Bintang', 'Puncak', 'Puncak Jaya', 'Sarmi', 'Supiori',
  'Tolikara', 'Waropen', 'Yahukimo', 'Yalimo',
  
  // ===== PAPUA BARAT =====
  'Manokwari', 'Sorong',
  'Fakfak', 'Kaimana', 'Manokwari Selatan', 'Maybrat', 'Pegunungan Arfak', 'Raja Ampat',
  'Sorong Selatan', 'Tambrauw', 'Teluk Bintuni', 'Teluk Wondama',
  
  // ===== PAPUA SELATAN =====
  'Asmat', 'Boven Digoel', 'Mappi',
  
  // ===== PAPUA TENGAH =====
  'Deiyai', 'Dogiyai', 'Intan Jaya',
  
  // ===== PAPUA PEGUNUNGAN =====
  // (Already included above)
  
  // ===== PAPUA BARAT DAYA =====
  // (Already included above)
].sort();

export default INDONESIAN_CITIES;

// Indonesian city coordinates (approximate)
export const CITY_COORDINATES = {
  // ===== DKI JAKARTA =====
  'Jakarta': [-6.2088, 106.8456],
  'Jakarta Selatan': [-6.2615, 106.8106],
  'Jakarta Pusat': [-6.1868, 106.8230],
  'Jakarta Barat': [-6.1683, 106.7588],
  'Jakarta Utara': [-6.1384, 106.8638],
  'Jakarta Timur': [-6.2250, 106.9004],
  
  // ===== JAWA BARAT =====
  'Bandung': [-6.9175, 107.6191],
  'Bogor': [-6.5950, 106.8166],
  'Bekasi': [-6.2383, 106.9756],
  'Depok': [-6.4025, 106.7942],
  'Cirebon': [-6.7063, 108.5571],
  'Sukabumi': [-6.9277, 106.9300],
  'Tasikmalaya': [-7.3506, 108.2172],
  'Cimahi': [-6.8841, 107.5413],
  'Garut': [-7.2275, 107.9089],
  'Karawang': [-6.3227, 107.3376],
  'Subang': [-6.5714, 107.7611],
  'Purwakarta': [-6.5569, 107.4357],
  'Cianjur': [-6.8204, 107.1430],
  'Majalengka': [-6.8365, 108.2274],
  'Indramayu': [-6.3276, 108.3222],
  'Kuningan': [-6.9756, 108.4836],
  
  // ===== BANTEN =====
  'Tangerang': [-6.1783, 106.6319],
  'Tangerang Selatan': [-6.2886, 106.7170],
  'Serang': [-6.1103, 106.1640],
  'Cilegon': [-6.0023, 106.0507],
  'Lebak': [-6.5641, 106.2522],
  'Pandeglang': [-6.3089, 106.1069],
  
  // ===== JAWA TENGAH =====
  'Semarang': [-6.9667, 110.4167],
  'Surakarta': [-7.5755, 110.8243],
  'Magelang': [-7.4797, 110.2177],
  'Salatiga': [-7.3305, 110.5084],
  'Pekalongan': [-6.8885, 109.6753],
  'Tegal': [-6.8797, 109.1256],
  'Kudus': [-6.8048, 110.8405],
  'Jepara': [-6.5935, 110.6727],
  'Demak': [-6.8936, 110.6400],
  'Kendal': [-6.9194, 110.2038],
  'Brebes': [-6.8733, 109.0383],
  'Cilacap': [-7.7268, 109.0154],
  'Banyumas': [-7.4832, 109.1403],
  'Purbalingga': [-7.3903, 109.3631],
  'Kebumen': [-7.6711, 109.6504],
  'Purworejo': [-7.7083, 110.0050],
  'Wonosobo': [-7.3631, 109.9025],
  'Temanggung': [-7.3172, 110.1756],
  'Klaten': [-7.7056, 110.6039],
  'Boyolali': [-7.5316, 110.5950],
  'Sragen': [-7.4267, 111.0217],
  'Karanganyar': [-7.5978, 110.9583],
  'Wonogiri': [-7.8078, 110.9269],
  'Sukoharjo': [-7.6819, 110.8369],
  'Blora': [-6.9667, 111.4167],
  'Rembang': [-6.7081, 111.3500],
  'Pati': [-6.7500, 111.0400],
  'Grobogan': [-7.0167, 110.8833],
  'Batang': [-6.8950, 109.7256],
  'Pemalang': [-6.8892, 109.3828],
  
  // ===== DI YOGYAKARTA =====
  'Yogyakarta': [-7.7956, 110.3695],
  'Sleman': [-7.7167, 110.3556],
  'Bantul': [-7.8894, 110.3278],
  'Gunungkidul': [-7.9833, 110.6000],
  'Kulon Progo': [-7.8167, 110.1667],
  
  // ===== JAWA TIMUR =====
  'Surabaya': [-7.2575, 112.7521],
  'Malang': [-7.9797, 112.6304],
  'Batu': [-7.8672, 112.5239],
  'Kediri': [-7.8480, 112.0178],
  'Blitar': [-8.0986, 112.1681],
  'Madiun': [-7.6298, 111.5239],
  'Mojokerto': [-7.4722, 112.4336],
  'Pasuruan': [-7.6469, 112.9075],
  'Probolinggo': [-7.7543, 113.2159],
  'Sidoarjo': [-7.4478, 112.7183],
  'Gresik': [-7.1625, 112.6513],
  'Lamongan': [-7.1200, 112.4172],
  'Tuban': [-6.8986, 112.0500],
  'Bojonegoro': [-7.1500, 111.8833],
  'Ngawi': [-7.4047, 111.4461],
  'Magetan': [-7.6464, 111.3586],
  'Ponorogo': [-7.8686, 111.4608],
  'Pacitan': [-8.1942, 111.1014],
  'Trenggalek': [-8.0500, 111.7167],
  'Tulungagung': [-8.0656, 111.9028],
  'Nganjuk': [-7.6056, 111.9031],
  'Jombang': [-7.5458, 112.2342],
  'Lumajang': [-8.1333, 113.2167],
  'Jember': [-8.1845, 113.6681],
  'Banyuwangi': [-8.2186, 114.3691],
  'Bondowoso': [-7.9167, 113.8167],
  'Situbondo': [-7.7069, 114.0042],
  'Bangkalan': [-7.0456, 112.7356],
  'Sampang': [-7.1833, 113.2500],
  'Pamekasan': [-7.1583, 113.4833],
  'Sumenep': [-7.0167, 113.8667],
  
  // ===== ACEH =====
  'Banda Aceh': [5.5483, 95.3238],
  'Langsa': [4.4761, 97.9683],
  'Lhokseumawe': [5.1801, 97.1507],
  'Sabang': [5.8833, 95.3167],
  'Aceh Besar': [5.3833, 95.5167],
  'Aceh Utara': [5.0833, 97.1500],
  'Aceh Timur': [4.6333, 97.7833],
  'Aceh Selatan': [3.1667, 97.3333],
  'Aceh Barat': [4.4500, 96.1667],
  'Pidie': [5.3167, 96.0167],
  'Bireuen': [5.2000, 96.7000],
  
  // ===== SUMATERA UTARA =====
  'Medan': [3.5952, 98.6722],
  'Binjai': [3.6000, 98.4833],
  'Pematangsiantar': [2.9597, 99.0681],
  'Tebing Tinggi': [3.3167, 99.1500],
  'Padangsidimpuan': [1.3833, 99.2667],
  'Sibolga': [1.7333, 98.7833],
  'Tanjungbalai': [2.9667, 99.8000],
  'Deli Serdang': [3.4167, 98.7667],
  'Langkat': [3.7667, 98.2833],
  'Asahan': [2.9833, 99.6500],
  'Labuhanbatu': [2.1167, 99.8333],
  'Simalungun': [2.9333, 99.0000],
  'Karo': [3.1000, 98.4667],
  'Tapanuli Utara': [2.0167, 99.0500],
  'Tapanuli Tengah': [1.8167, 98.6833],
  'Tapanuli Selatan': [1.5333, 99.3333],
  'Nias': [1.0500, 97.6667],
  'Samosir': [2.6167, 98.7167],
  'Toba Samosir': [2.5167, 99.0667],
  
  // ===== SUMATERA BARAT =====
  'Padang': [-0.9471, 100.4172],
  'Bukittinggi': [-0.3047, 100.3694],
  'Payakumbuh': [-0.2200, 100.6300],
  'Pariaman': [-0.6300, 100.1200],
  'Padang Panjang': [-0.4667, 100.4167],
  'Sawahlunto': [-0.6833, 100.7667],
  'Solok': [-0.7892, 100.6531],
  'Agam': [-0.2500, 100.3333],
  'Pasaman': [0.1000, 99.9167],
  'Pasaman Barat': [0.0167, 99.5833],
  'Lima Puluh Kota': [-0.1333, 100.5500],
  'Tanah Datar': [-0.4667, 100.5833],
  'Sijunjung': [-0.6667, 100.9500],
  'Pesisir Selatan': [-1.3500, 100.5833],
  'Padang Pariaman': [-0.5167, 100.1500],
  
  // ===== RIAU =====
  'Pekanbaru': [0.5071, 101.4478],
  'Dumai': [1.6667, 101.4500],
  'Kampar': [0.3833, 101.0833],
  'Bengkalis': [1.4833, 102.1333],
  'Rokan Hilir': [1.9500, 101.5000],
  'Rokan Hulu': [0.8500, 100.3833],
  'Siak': [1.3833, 102.0500],
  'Pelalawan': [0.6000, 102.2500],
  'Indragiri Hulu': [-0.3333, 102.3333],
  'Indragiri Hilir': [-0.3500, 103.0667],
  'Kuantan Singingi': [-0.5333, 101.5333],
  'Kepulauan Meranti': [1.0833, 102.8333],
  
  // ===== KEPULAUAN RIAU =====
  'Batam': [1.0456, 104.0305],
  'Tanjung Pinang': [0.9167, 104.4500],
  'Bintan': [1.0333, 104.5333],
  'Karimun': [1.0333, 103.4167],
  'Natuna': [3.9000, 108.3833],
  'Lingga': [-0.2000, 104.6000],
  
  // ===== JAMBI =====
  'Jambi': [-1.6101, 103.6131],
  'Sungai Penuh': [-2.0833, 101.3833],
  'Batanghari': [-1.6833, 103.0500],
  'Muaro Jambi': [-1.5000, 103.6667],
  'Tanjung Jabung Barat': [-1.1000, 103.4167],
  'Tanjung Jabung Timur': [-1.0833, 104.0333],
  'Bungo': [-1.5000, 102.1333],
  'Tebo': [-1.4333, 102.4500],
  'Merangin': [-2.1333, 102.1333],
  'Sarolangun': [-2.3167, 102.7167],
  'Kerinci': [-2.0000, 101.3000],
  
  // ===== SUMATERA SELATAN =====
  'Palembang': [-2.9761, 104.7754],
  'Lubuklinggau': [-3.2833, 102.8500],
  'Prabumulih': [-3.4333, 104.2333],
  'Pagar Alam': [-4.0167, 103.2500],
  'Muara Enim': [-3.6833, 103.7500],
  'Lahat': [-3.7833, 103.5333],
  'Musi Banyuasin': [-2.9167, 104.0833],
  'Banyuasin': [-2.5000, 104.7500],
  'Ogan Komering Ilir': [-3.2000, 105.4167],
  'Ogan Komering Ulu': [-4.1333, 104.0333],
  'Ogan Ilir': [-3.2167, 104.6333],
  'Empat Lawang': [-3.7667, 103.0667],
  
  // ===== BENGKULU =====
  'Bengkulu': [-3.8004, 102.2655],
  'Bengkulu Utara': [-3.4500, 102.1500],
  'Bengkulu Selatan': [-4.4167, 103.0167],
  'Rejang Lebong': [-3.4667, 102.6500],
  'Kepahiang': [-3.6167, 102.5500],
  'Lebong': [-3.2500, 102.3833],
  'Kaur': [-4.5333, 103.4167],
  'Seluma': [-4.0500, 102.5000],
  'Mukomuko': [-2.5833, 101.1000],
  
  // ===== LAMPUNG =====
  'Bandar Lampung': [-5.4292, 105.2619],
  'Metro': [-5.1167, 105.3000],
  'Lampung Selatan': [-5.6500, 105.5833],
  'Lampung Tengah': [-4.8000, 105.2833],
  'Lampung Utara': [-4.8333, 104.7500],
  'Lampung Timur': [-5.0833, 105.7000],
  'Lampung Barat': [-5.1167, 104.2500],
  'Tulang Bawang': [-4.4500, 105.5000],
  'Tulang Bawang Barat': [-4.4667, 105.0500],
  'Tanggamus': [-5.4667, 104.6167],
  'Pesawaran': [-5.4167, 105.0833],
  'Pringsewu': [-5.3667, 104.9667],
  'Mesuji': [-4.0500, 105.4833],
  'Way Kanan': [-4.5500, 104.5167],
  'Pesisir Barat': [-5.2500, 103.9667],
  
  // ===== BANGKA BELITUNG =====
  'Pangkal Pinang': [-2.1333, 106.1167],
  'Bangka': [-2.0000, 105.9167],
  'Bangka Barat': [-2.0500, 105.4000],
  'Bangka Selatan': [-2.8167, 106.2167],
  'Bangka Tengah': [-2.3333, 106.2333],
  'Belitung': [-2.8500, 107.6333],
  'Belitung Timur': [-2.8667, 108.0333],
  
  // ===== KALIMANTAN BARAT =====
  'Pontianak': [-0.0263, 109.3425],
  'Singkawang': [0.9000, 108.9833],
  'Ketapang': [-1.8297, 109.9773],
  'Sambas': [1.3500, 109.3000],
  'Sanggau': [0.1333, 110.5833],
  'Sintang': [0.0667, 111.4833],
  'Kapuas Hulu': [0.9667, 112.9333],
  'Sekadau': [-0.0333, 110.9333],
  'Melawi': [-0.2833, 111.5500],
  'Kayong Utara': [-1.5000, 109.9500],
  'Kubu Raya': [-0.1833, 109.4833],
  'Bengkayang': [0.8167, 109.5500],
  'Landak': [0.3500, 109.9500],
  'Mempawah': [0.3500, 109.0500],
  
  // ===== KALIMANTAN TENGAH =====
  'Palangkaraya': [-2.2089, 113.9213],
  'Kotawaringin Barat': [-2.5333, 111.6333],
  'Kotawaringin Timur': [-2.5167, 112.9500],
  'Kapuas': [-2.9500, 114.0667],
  'Barito Selatan': [-2.5500, 114.7833],
  'Barito Utara': [-1.3667, 115.0500],
  'Barito Timur': [-2.0000, 115.3500],
  'Murung Raya': [-0.6833, 114.3500],
  'Gunung Mas': [-1.2833, 113.6833],
  'Pulang Pisau': [-2.8333, 114.0667],
  'Katingan': [-1.8667, 113.4167],
  'Seruyan': [-3.0000, 112.4833],
  'Sukamara': [-2.8667, 111.1833],
  'Lamandau': [-2.4667, 111.1500],
  
  // ===== KALIMANTAN SELATAN =====
  'Banjarmasin': [-3.3194, 114.5906],
  'Banjarbaru': [-3.4500, 114.8167],
  'Banjar': [-3.3000, 114.9667],
  'Tapin': [-2.9667, 115.0167],
  'Hulu Sungai Selatan': [-2.7667, 115.1333],
  'Hulu Sungai Tengah': [-2.5833, 115.3500],
  'Hulu Sungai Utara': [-2.4500, 115.4667],
  'Tabalong': [-2.0500, 115.5500],
  'Tanah Laut': [-3.7500, 114.8333],
  'Tanah Bumbu': [-3.4667, 115.7000],
  'Kotabaru': [-3.2833, 116.2167],
  'Barito Kuala': [-3.0667, 114.5833],
  'Balangan': [-2.3000, 115.6167],
  
  // ===== KALIMANTAN TIMUR =====
  'Samarinda': [-0.5022, 117.1536],
  'Balikpapan': [-1.2379, 116.8529],
  'Bontang': [0.1333, 117.5000],
  'Kutai Kartanegara': [-0.4500, 116.9833],
  'Kutai Barat': [0.0333, 115.8167],
  'Kutai Timur': [0.6833, 117.2000],
  'Paser': [-1.9333, 116.2667],
  'Penajam Paser Utara': [-1.2000, 116.6500],
  'Berau': [2.1667, 117.4833],
  'Mahakam Ulu': [0.5333, 115.5833],
  
  // ===== KALIMANTAN UTARA =====
  'Tarakan': [3.3000, 117.6333],
  'Nunukan': [4.1333, 117.6500],
  'Malinau': [3.5833, 116.6333],
  'Bulungan': [2.8500, 117.1500],
  'Tana Tidung': [3.6333, 116.3833],
  
  // ===== SULAWESI UTARA =====
  'Manado': [1.4748, 124.8421],
  'Bitung': [1.4444, 125.1992],
  'Tomohon': [1.3167, 124.8500],
  'Kotamobagu': [0.7333, 124.3167],
  'Minahasa': [1.3000, 124.9000],
  'Minahasa Utara': [1.4833, 125.0500],
  'Minahasa Selatan': [1.0833, 124.5500],
  'Minahasa Tenggara': [1.0500, 124.8333],
  'Bolaang Mongondow': [0.8667, 124.0500],
  'Bolaang Mongondow Utara': [0.8667, 124.0500],
  'Bolaang Mongondow Selatan': [0.6000, 123.9333],
  'Bolaang Mongondow Timur': [0.8167, 124.5167],
  'Kepulauan Sangihe': [3.5667, 125.5000],
  'Kepulauan Talaud': [4.0833, 126.8167],
  
  // ===== SULAWESI TENGAH =====
  'Palu': [-0.8999, 119.8707],
  'Donggala': [-0.6833, 119.7500],
  'Poso': [-1.3833, 120.7667],
  'Toli-Toli': [1.0500, 120.7833],
  'Buol': [1.0833, 121.4333],
  'Banggai': [-1.5667, 123.0500],
  'Banggai Kepulauan': [-1.4167, 123.4833],
  'Morowali': [-2.2000, 121.5167],
  'Parigi Moutong': [-0.3333, 120.2000],
  'Sigi': [-1.2000, 119.8833],
  'Tojo Una-Una': [-1.0167, 122.0167],
  
  // ===== SULAWESI SELATAN =====
  'Makassar': [-5.1477, 119.4327],
  'Palopo': [-2.9917, 120.1972],
  'Parepare': [-4.0167, 119.6167],
  'Gowa': [-5.3167, 119.4500],
  'Maros': [-5.0000, 119.5667],
  'Pangkajene dan Kepulauan': [-4.8333, 119.5500],
  'Barru': [-4.4000, 119.6333],
  'Bone': [-4.5386, 120.3267],
  'Watampone': [-4.5386, 120.3267],
  'Wajo': [-4.0333, 120.2167],
  'Soppeng': [-4.3500, 119.9000],
  'Sinjai': [-5.1333, 120.2500],
  'Bulukumba': [-5.5500, 120.1833],
  'Bantaeng': [-5.5000, 119.9500],
  'Jeneponto': [-5.6333, 119.6833],
  'Takalar': [-5.4167, 119.4500],
  'Selayar': [-6.1167, 120.4667],
  'Pinrang': [-3.7833, 119.6500],
  'Sidenreng Rappang': [-3.9167, 119.9500],
  'Enrekang': [-3.5500, 119.8167],
  'Luwu': [-2.8667, 120.4500],
  'Luwu Utara': [-2.5667, 120.3500],
  'Luwu Timur': [-2.5500, 121.1167],
  'Tana Toraja': [-3.0667, 119.9000],
  'Toraja Utara': [-2.9167, 119.9167],
  
  // ===== SULAWESI TENGGARA =====
  'Kendari': [-3.9450, 122.5989],
  'Baubau': [-5.4667, 122.6167],
  'Kolaka': [-4.0333, 121.5833],
  'Kolaka Utara': [-3.3333, 121.0500],
  'Konawe': [-3.9333, 122.0167],
  'Konawe Selatan': [-4.4167, 122.4000],
  'Konawe Utara': [-3.3833, 122.2667],
  'Bombana': [-4.7500, 121.8500],
  'Wakatobi': [-5.3167, 123.6333],
  'Buton': [-5.2333, 122.8833],
  'Buton Utara': [-4.8833, 122.8500],
  'Muna': [-4.8833, 122.6500],
  
  // ===== GORONTALO =====
  'Gorontalo': [0.5435, 123.0596],
  'Bone Bolango': [0.5333, 123.2667],
  'Boalemo': [0.5833, 122.1500],
  'Pohuwato': [0.6833, 121.6333],
  'Gorontalo Utara': [0.9333, 122.4500],
  
  // ===== SULAWESI BARAT =====
  'Mamuju': [-2.6667, 118.8833],
  'Majene': [-3.5333, 118.9667],
  'Polewali Mandar': [-3.4000, 119.3333],
  'Mamasa': [-3.0500, 119.3500],
  'Mamuju Tengah': [-2.2167, 119.3167],
  'Pasangkayu': [-1.4167, 119.3667],
  
  // ===== BALI =====
  'Denpasar': [-8.6705, 115.2126],
  'Badung': [-8.5833, 115.1833],
  'Gianyar': [-8.5333, 115.3167],
  'Tabanan': [-8.5333, 115.1167],
  'Karangasem': [-8.4500, 115.6167],
  'Klungkung': [-8.5333, 115.4167],
  'Bangli': [-8.4500, 115.3500],
  'Buleleng': [-8.1167, 115.0833],
  'Jembrana': [-8.3500, 114.6333],
  
  // ===== NUSA TENGGARA BARAT =====
  'Mataram': [-8.5833, 116.1167],
  'Bima': [-8.4667, 118.7167],
  'Lombok Barat': [-8.6167, 116.0667],
  'Lombok Tengah': [-8.7000, 116.2833],
  'Lombok Timur': [-8.5167, 116.5333],
  'Lombok Utara': [-8.3333, 116.4667],
  'Sumbawa': [-8.5000, 117.4167],
  'Sumbawa Barat': [-8.7833, 116.9000],
  'Dompu': [-8.5333, 118.4667],
  
  // ===== NUSA TENGGARA TIMUR =====
  'Kupang': [-10.1718, 123.6075],
  'Ende': [-8.8500, 121.6500],
  'Flores Timur': [-8.3167, 122.9833],
  'Sikka': [-8.6500, 122.1333],
  'Ngada': [-8.7000, 121.0000],
  'Nagekeo': [-8.8000, 121.2000],
  'Manggarai': [-8.5667, 120.4167],
  'Manggarai Barat': [-8.5667, 119.8833],
  'Manggarai Timur': [-8.6167, 120.8000],
  'Lembata': [-8.3667, 123.5167],
  'Alor': [-8.2500, 124.7500],
  'Belu': [-9.1167, 124.9000],
  'Malaka': [-9.5667, 124.9000],
  'Timor Tengah Selatan': [-9.7333, 124.3500],
  'Timor Tengah Utara': [-9.4500, 124.6167],
  'Sumba Timur': [-9.9833, 120.2500],
  'Sumba Barat': [-9.4167, 119.3833],
  'Sumba Tengah': [-9.5833, 119.5333],
  'Sumba Barat Daya': [-9.6333, 119.0833],
  'Rote Ndao': [-10.7667, 123.0667],
  'Sabu Raijua': [-10.5167, 121.8833],
  
  // ===== MALUKU =====
  'Ambon': [-3.6954, 128.1814],
  'Tual': [-5.6500, 132.7500],
  'Maluku Tengah': [-3.3500, 128.9167],
  'Maluku Tenggara': [-5.7333, 132.6500],
  'Maluku Tenggara Barat': [-7.8833, 131.2000],
  'Buru': [-3.3833, 126.7500],
  'Buru Selatan': [-3.7667, 126.5167],
  'Kepulauan Aru': [-6.1000, 134.4000],
  'Seram Bagian Barat': [-3.0667, 128.0167],
  'Seram Bagian Timur': [-3.1833, 130.6500],
  'Maluku Barat Daya': [-8.1833, 127.5000],
  
  // ===== MALUKU UTARA =====
  'Ternate': [0.7875, 127.3678],
  'Tidore Kepulauan': [0.6833, 127.4000],
  'Halmahera Barat': [1.0833, 127.4833],
  'Halmahera Timur': [0.5167, 128.2500],
  'Halmahera Utara': [1.7667, 128.0167],
  'Halmahera Selatan': [-0.6000, 127.9167],
  'Halmahera Tengah': [0.4167, 128.2500],
  'Kepulauan Sula': [-1.8500, 125.4500],
  'Pulau Morotai': [2.3333, 128.3667],
  
  // ===== PAPUA =====
  'Jayapura': [-2.5489, 140.7182],
  'Biak Numfor': [-1.1833, 136.1000],
  'Nabire': [-3.3667, 135.5000],
  'Mimika': [-4.5500, 136.9000],
  'Merauke': [-8.4833, 140.4000],
  'Jayawijaya': [-4.1167, 138.9333],
  'Paniai': [-3.9333, 136.3667],
  'Puncak Jaya': [-4.0667, 137.2833],
  'Keerom': [-3.3833, 140.6833],
  'Sarmi': [-1.9167, 138.7500],
  'Tolikara': [-3.7500, 138.0833],
  'Yahukimo': [-4.7667, 139.5333],
  
  // ===== PAPUA BARAT =====
  'Sorong': [-0.8762, 131.2528],
  'Manokwari': [-0.8667, 134.0833],
  'Fakfak': [-2.9167, 132.3000],
  'Kaimana': [-3.6500, 133.7667],
  'Teluk Bintuni': [-2.1167, 133.5167],
  'Teluk Wondama': [-2.8000, 134.5333],
  'Raja Ampat': [-0.4167, 130.8167],
  'Tambrauw': [-0.8500, 132.4333],
  'Maybrat': [-1.2500, 132.3833],
  'Sorong Selatan': [-1.6667, 132.0167],
};
